import * as React from "react";
import { useNavigate } from "react-router-dom";
import { AppNavBar, setItemActive } from "baseui/app-nav-bar";
import { Overflow } from "baseui/icon";
import { useMsal } from "@azure/msal-react";
import { useGetCurrentUserQuery } from "../../services/msgraph/msGraphApi";
import { VscHome } from "react-icons/vsc";
import { useStyletron } from "baseui";
import { Logo } from "../../Logo";
import { FormattedMessage } from "react-intl";

const itemsAll = [{ icon: VscHome, label: "Home", href: "/subscriptions" }];

const AppNavigationBar = ({ subscriptionId }) => {
  const [css, theme] = useStyletron();
  const { data } = useGetCurrentUserQuery();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [mainItems, setMainItems] = React.useState(itemsAll);

  function signOutClickHandler() {
    instance.logoutPopup();
  }

  return (
    <AppNavBar
      title={
        <div
          className={css({
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          })}
          onClick={async () => {
            await navigate("/");
          }}>
          <Logo height={35} width={300} color={theme.colors.primary} />
          <FormattedMessage id="SubscriptionAdministration" defaultMessage={"Subscription Administration"} />
        </div>
      }
      mainItems={mainItems}
      onMainItemSelect={(item) => {
        setMainItems((prev) => setItemActive(prev, item));
        navigate(item.href);
      }}
      username={data?.displayName}
      usernameSubtitle={data?.mail}
      userItems={[{ icon: Overflow, label: "Logout" }]}
      onUserItemSelect={signOutClickHandler}
    />
  );
};

export default AppNavigationBar;
